<main class="ax-w-full ax-p-4">
  <ax-form #registerForm validationMessageMode="tooltip">
    <div class="ax-grid ax-grid-cols-1 ax-gap-4">
      <ax-form-field class="ax-w-full">
        <!-- شماره موبایل -->
        <!-- <ax-label>{{ 'profile.phoneNumber' | translate | async }}{{ settingData.agencyId !== 1900010 ? '/' + ('profile.email' | translate | async) : '' }}</ax-label> -->
        <ax-label>{{ settingData.agencyId === 1900010 ? ('profile.phoneNumber' | translate | async) :
          settingData.registerMethodTypeName ? settingData.registerMethodTypeName : ('profile.phoneNumber' | translate |
          async)+'/' +('profile.email' | translate | async) }}</ax-label>

        <ax-text-box dir="ltr" [(value)]="_registerObj.username">
          <!-- لطفا شماره موبایل خود را وارد کنید -->
          <ax-validation-rule rule="required" [message]='onErrorHandle()'></ax-validation-rule>
        </ax-text-box>
      </ax-form-field>
      <ng-container *ngIf="forgotPasswordFlag === 1">
        <ax-form-field class="ax-w-full">
          <ax-label>
            <!-- کلمه عبور -->
            {{ forgotPasswordFlag === 1 ? ('profile.newPassword' | translate | async) : ('profile.password' | translate
            | async) }}
          </ax-label>
          <ax-password-box dir="ltr" [(value)]="_registerObj.password">
            <!-- کلمه عبور اجباری است -->
            <ax-validation-rule rule="required"
              [message]="('profile.passwordRequired' | translate | async)!"></ax-validation-rule>
          </ax-password-box>
        </ax-form-field>
        <ax-form-field class="ax-w-full">
          <ax-label>
            <!-- تکرار کلمه عبور جدید -->
            {{ forgotPasswordFlag === 1 ? ('profile.repeatTheNewPassword' | translate | async) :
            ('profile.repeatPassword' | translate | async) }}
          </ax-label>
          <ax-password-box dir="ltr" [(value)]="_registerObj.passwordConfirm">
            <!-- تکرار کلمه عبور اجباری است -->
            <ax-validation-rule rule="required"
              [message]="('profile.reapetPasswordRequired' | translate | async)!"></ax-validation-rule>
          </ax-password-box>
        </ax-form-field>
      </ng-container>
      <div class="ax-relative ax-flex ax-h-20 ax-w-full ax-rounded ax-border ax-border-default">
        <img [src]="'data:image/png;base64,' + _captchaCodeObject.image" [alt]="'profile.captcha' | translate | async"
          class="ax-h-full ax-w-full ax-rounded ax-object-cover" />
        <ax-button class="ax-absolute ax-bottom-[-0.5rem] ax-end-[-0.5rem] ax-rounded-full ax-sm" color="secondary"
          (onClick)="getCaptchaGenerate()" [disabled]="isLoading">
          <ax-prefix *ngIf="!isLoading">
            <i class="fa-solid fa-rotate-right"></i>
          </ax-prefix>
          <ax-loading *ngIf="isLoading"></ax-loading>
        </ax-button>
      </div>
      <ax-form-field class="ax-w-full">
        <!-- کد‌امنیتی -->
        <ax-label>{{ 'profile.captcha' | translate | async }}</ax-label>
        <ax-text-box dir="ltr" [(value)]="_registerObj.captchaCode">
          <!-- کد‌امنیتی را وارد نمایید -->
          <ax-validation-rule rule="required"
            [message]="('profile.captchaRequired' | translate | async)!"></ax-validation-rule>
        </ax-text-box>
      </ax-form-field>

      <div *ngIf="activationCode">
        <ax-form-field class="ax-w-full" *ngIf="continue">
          <!-- کد فعال‌سازی....برای ورود از همین رمز استفاده کنید -->
          <ax-label>{{ 'profile.activationCode' | translate | async }} {{ forgotPasswordFlag !== 1 ?
            ('profile.loginWithPassword' | translate | async)! : '' }}</ax-label>
          <ax-text-box dir="ltr" [(value)]="_registerObj.activationCode" [maxLength]="5">
            <!-- کد فعال‌سازی اجباری است -->
            <ax-validation-rule rule="required"
              [message]="('profile.activationCodeRequired' | translate | async)!"></ax-validation-rule>
          </ax-text-box>
        </ax-form-field>
        <div class="d-flex align-items-center justify-content-center mb-2">
          <!-- زمان باقی‌مانده -->
          <label>{{ 'profile.remainingTime' | translate | async }}: {{ second }} {{ 'profile.second' | translate | async
            }}</label>
        </div>
      </div>
      <!-- ارسال کد فعال‌سازی -->
      <ax-button [text]="'profile.sendActivationCode' | translate | async" class="ax-w-full" (onClick)="onSubmitClick()"
        color="primary" [disabled]="isLoading" *ngIf="submit">
        <ax-suffix>
          <ax-loading *ngIf="isLoading"></ax-loading>
        </ax-suffix>
      </ax-button>
      <!-- ارسال کد فعال‌سازی  ############################# -->
      <ax-button [text]="'profile.sendActivationCode' | translate | async" class="ax-w-full"
        (onClick)="onRegisterClick()" color="primary" [disabled]="isLoading" *ngIf="continue">
        <ax-suffix>
          <ax-loading *ngIf="isLoading"></ax-loading>
        </ax-suffix>
      </ax-button>
      <!-- ارسال مجدد کد فعال‌سازی -->
      <ax-button [text]="'profile.resendActivationCode' | translate | async" color="secondary" class="ax-w-full"
        (onClick)="onSubmitClick()" [disabled]="isLoading" *ngIf="resend">
        <ax-suffix>
          <ax-loading *ngIf="isLoading"></ax-loading>
        </ax-suffix>
      </ax-button>
    </div>
  </ax-form>
</main>